import { useGetFrontRichiesteIdTipiComunicazione } from '@framework/api-client/api/inquiries-compile/comunicazioni-inalterate/comunicazioni-inalterate.ts';
import { GetFrontRichiesteIdTipiComunicazioneTipo } from '@framework/api-client/api/inquiries-compile/schemas/getFrontRichiesteIdTipiComunicazioneTipo.ts';
import { useMemo } from 'react';

export function useFrontofficeCommunicationsTypes(
  submissionId: string | null | undefined,
) {
  const { data: sendableTypesData } = useGetFrontRichiesteIdTipiComunicazione(
    submissionId!,
    {
      ordinaPerCodice: true,
      tipo: GetFrontRichiesteIdTipiComunicazioneTipo.INVIABILE,
    },
    { query: { enabled: submissionId != null, keepPreviousData: true } },
  );
  const sendableTypes = useMemo(
    () => sendableTypesData ?? [],
    [sendableTypesData],
  );

  const { data: receivableTypesData } = useGetFrontRichiesteIdTipiComunicazione(
    submissionId!,
    {
      ordinaPerCodice: true,
      tipo: GetFrontRichiesteIdTipiComunicazioneTipo.RICEVIBILE,
    },
    { query: { enabled: submissionId != null, keepPreviousData: true } },
  );

  const receivableTypes = useMemo(
    () => receivableTypesData ?? [],
    [receivableTypesData],
  );

  // Tipi comunicazione ricercabili
  const { data: searchableTypesData } = useGetFrontRichiesteIdTipiComunicazione(
    submissionId!,
    {
      ordinaPerCodice: true,
      tipo: GetFrontRichiesteIdTipiComunicazioneTipo.RICERCABILE,
    },
    { query: { enabled: submissionId != null } },
  );

  const searchableTypes = useMemo(
    () => searchableTypesData ?? [],
    [searchableTypesData],
  );

  return { sendableTypes, receivableTypes, searchableTypes };
}
